/**
 * Top-level `params` keys that are not coordinator catalog extras.
 * Any other primitive key is treated as a catalog dynamic field for load/save/stale cleanup.
 * Update this set when new first-class connector params are added.
 */
const RAG_PARAM_KEYS = [
  'embeddingProvider',
  'embeddingModelName',
  'vectorDimension',
  'projectId',
  'location',
  'endpoint',
  'publisher',
  'maxRetries',
  'waitForModel',
  'maxResults',
  'minScore',
  'vectorStoreProvider',
  'host',
  'port',
  'database',
  'tableName',
  'indexName',
  'uri',
  'label',
  'embeddingProperty',
  'textProperty'
] as const;

/** Default PII guardrail param keys (must match guardrailsToParams fallback mapping). */
export const GUARDRAILS_PII_PARAM_KEYS = [
  'checkEmail',
  'phoneNumberCheck',
  'creditCardCheck',
  'ipAddressCheck',
  'checkDateOrTime',
  'cpfCheck',
  'cnpjCheck',
  'cryptocurrencyCheck',
  'checkURL',
  'checkIBAN',
  'maskOnDetection'
] as const;

export const AGENT_CONNECTOR_RESERVED_PARAM_KEYS = new Set<string>([
  'llmProvider',
  'useCustomModel',
  'customModel',
  'selectedModelId',
  'modelsAnthropicClaude',
  'modelsDeepSeek',
  'modelsGoogleGemini',
  'modelsOpenAI',
  'modelsAzureOpenAi',
  'modelsAmazonBedrock',
  'mcpServer',
  'systemPrompt',
  'userPrompt',
  'files',
  'useJsonSchema',
  'jsonSchema',
  'useOutputFormatBody',
  'outputFormatBody',
  'useFullModeResponse',
  'maxOutputTokens',
  'temperature',
  'topK',
  'topP',
  'frequencyPenalty',
  'presencePenalty',
  'customParameters',
  'timeout',
  'modelMaxRetries',
  'failOnError',
  'customUrl',
  'allowInsecureConnections',
  /** Legacy; removed on save, still read for migration */
  'catalogDynamicParams',
  'enableRAG',
  ...RAG_PARAM_KEYS,
  'detectPII',
  'jsonSchemaCheck',
  'customRegex',
  ...GUARDRAILS_PII_PARAM_KEYS,
  /** Serialized guardrails blob when used */
  'guardrails',
  'messages'
]);

/** Legacy MCP flattened header/query keys at top level of params */
const MCP_FLATTENED_KEY_RE = /^(mcpHeaders|mcpQueryParams)-\d+-(key|value)$/;

export function isReservedOrStructuralAgentConnectorParamKey(
  key: string
): boolean {
  if (AGENT_CONNECTOR_RESERVED_PARAM_KEYS.has(key)) return true;
  if (MCP_FLATTENED_KEY_RE.test(key)) return true;
  return false;
}
